import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import WhiteLEhero from "./WhiteLEhero";
import Elevate from "./Elevate";
import SecurityWLE from "./SecurityWLE";
import WhatWL from "./WhatWL";
import OurProcess from "./OurProcess";
import SelectedWork from "./SelectedWork";
import Interested from "./Interested";

function WhiteLabelExchange() {
  return (
    <div>
      <Header />
      <WhiteLEhero />
      <WhatWL />
      <Elevate />
      <OurProcess />
      <Interested />
      <SelectedWork />
      <SecurityWLE />
      <Footer />
    </div>
  );
}

export default WhiteLabelExchange;
